import { forwardRef } from 'react';
import { Box, BoxProps, useStyleConfig } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';

const CardTitleStyles: ComponentStyleConfig = {
  baseStyle: {
    display: 'flex',
    flexDir: 'row',
    justifyContent: 'space-between',
    bgColor: 'base2Colour.500',
    mb: 2.5,
    py: 2.5,
    px: 5,
    alignItems: 'center',
    fontSize: 'md',
  },
};

const CardTitle = forwardRef<HTMLDivElement, BoxProps>(({ children, ...props }: BoxProps, ref) => {
  const styles = useStyleConfig('CardTitle');
  return (
    <Box __css={styles} ref={ref} {...props}>
      {children}
    </Box>
  );
});

export { CardTitle, CardTitleStyles };
